import { createPaginatedKey } from "api/keys";

export const orderKeys = {
  itemsWithSingleQuantities: createPaginatedKey("itemsWithSingleQuantities"),
  singleItemQuantities: createPaginatedKey("singleItemQuantities"),
  singleItemQuantitiesDetails: createPaginatedKey("singleItemQuantitiesDetails"),
};
